import { Suspense, type ReactNode } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Spinner } from '@opus/ui-components';
import { Navbar } from './Navbar';
import { Footer } from './Footer';

/**
 * Single <main> landmark (the duplicate-chrome audit bug dies here), skip link,
 * navbar offset. Heavy route chunks resolve inside the Suspense boundary.
 */
export function Layout({ children }: { children?: ReactNode }) {
  const { pathname } = useLocation();
  return (
    <div className="flex min-h-screen flex-col">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-50 focus:bg-card focus:px-3 focus:py-2"
      >
        skip to content
      </a>
      <Navbar />
      <main id="main" className="mx-auto w-full max-w-6xl flex-grow px-4 pb-16 pt-20">
        <Suspense key={pathname} fallback={<div className="flex justify-center py-24"><Spinner /></div>}>
          {children ?? <Outlet />}
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
